// Data hook: fetch collections from backend once and cache them.
import { useEffect, useState } from "react";
import { api } from "./api";

const cache = {};

export const useCollection = (coll) => {
  const [data, setData] = useState(cache[coll] || null);
  useEffect(() => {
    let alive = true;
    if (cache[coll]) {
      setData(cache[coll]);
      return;
    }
    api.list(coll).then((d) => {
      cache[coll] = d;
      if (alive) setData(d);
    }).catch(() => {
      if (alive) setData([]);
    });
    return () => { alive = false; };
  }, [coll]);
  return data;
};

export const useSettings = () => {
  const [data, setData] = useState(cache._settings || null);
  useEffect(() => {
    let alive = true;
    if (cache._settings) { setData(cache._settings); return; }
    api.getSettings().then((d) => {
      cache._settings = d;
      if (alive) setData(d);
    }).catch(() => { if (alive) setData({}); });
    return () => { alive = false; };
  }, []);
  return data;
};

export const useHomeSlides = () => {
  const [data, setData] = useState(cache._homeSlides || null);
  useEffect(() => {
    let alive = true;
    if (cache._homeSlides) { setData(cache._homeSlides); return; }
    api.getHomeSlides().then((d) => {
      cache._homeSlides = d;
      if (alive) setData(d);
    }).catch(() => { if (alive) setData([]); });
    return () => { alive = false; };
  }, []);
  return data;
};

export const invalidateCache = () => {
  Object.keys(cache).forEach((k) => delete cache[k]);
};
